import axios from 'axios';
import { REACT_APP_ENDPOINT, REACT_APP_SENRSOFT_URL } from 'config/env';

const FIELDS_SEPERATOR = ',';

/* =========================================== local function =========================================== */
const initiateHTTPClient = () => {
  const httpClient = axios.create({
    baseURL: REACT_APP_ENDPOINT,
    timeout: 300000,
    ...getAuthHeader()
  });

  httpClient.interceptors.request.use(req => {
    mutateParamsArrayToString(req.params);
    return req;
  });

  return httpClient;
};

const mutateParamsArrayToString = params => {
  if (!!params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        const valueInString = value.join(FIELDS_SEPERATOR);
        params[key] = valueInString;
      }
    });
  }
};

/* =========================================== exported function =========================================== */
export let httpClient = initiateHTTPClient();

export let httpClientCustom = CUSTOM_APP_ENDPOINT => {
  const httpClient = axios.create({
    // baseURL: CUSTOM_APP_ENDPOINT,
    baseURL: REACT_APP_SENRSOFT_URL,
    timeout: 300000,
    ...(localStorage.getItem('userToken')
      ? {
          headers: {
            Authorization: 'JWT ' + localStorage.getItem('userToken')
          }
        }
      : {})
  });

  httpClient.interceptors.request.use(req => {
    mutateParamsArrayToString(req.params);
    return req;
  });

  return httpClient;
};

export const postLogin = credentials => {
  return httpClient
    .post('/auth/login', credentials)
    .then(response => {
      localStorage.setItem('auth', JSON.stringify(response.data));
      httpClient = initiateHTTPClient();

      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export function getAuthHeader() {
  if (localStorage.getItem('auth') && localStorage.getItem('auth') !== 'undefined') {
    const auth = JSON.parse(localStorage.getItem('auth'));
    const token = auth && auth.token;
    if (!token) return undefined;
    const authValue = typeof token === 'string' && token.startsWith('JWT ') ? token : `JWT ${token}`;
    return {
      headers: {
        Authorization: authValue
      }
    };
  }
}

/**
 * Stores auth data and re-initializes the HTTP client so subsequent requests use the new token.
 * Used after session-login (and legacy login) success.
 */
export function setAuthAndReinit(authData) {
  localStorage.setItem('auth', JSON.stringify(authData));
  httpClient = initiateHTTPClient();
}
